// initial state
const state = {
  adminUsers: ["dcairns", "nswa_me", "BRWA_Sarah", "RDRWA_Josee"],
  showAuth: false,
  user: null,
  authenticated: false,
  userAdded: false,
  termsDocURL: "https://docs.google.com/document/d/e/2PACX-1vQTwCXm01G5uJKKuOn0_mNqEUoKqlllT9cnt2fBO2phtLv7fjcqPsCBNfczaXZ1RX4KlfrbsHL0MXMf/pub?embedded=true"
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  changeAuth(state, payload) {
    state.authenticated = payload.authenticated;
    if (payload.authenticated) state.user = payload.user;
    else state.user = null;
  },
  userAdded(state) {
    state.userAdded = true;
    setTimeout(() => {
      state.userAdded = false;
    }, 3000);
  },
  toggleAuthModal(state, value) {
    state.showAuth = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
